import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiSurveyRecipientsError } from '@/core/error/transport/customErrors/tmApiSurveyRecipientsError'

export const smsSurveyRecipientsErrorRule: CustomErrorRule = {
  klass: TmApiSurveyRecipientsError,
  subCodes: ['survey.recipient_countries_not_covered'],
  // @todo: endpoint with params doesn't work here
  // endpoint: EndpointsEnum.surveyStart,
}
